// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"usbAttackModal__wrapper","box-wrapper":"usbAttackModal__box-wrapper"};